import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { QuillEditorContainer } from './styles';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  error?: boolean;
  mensageError?: string;
  block?: boolean;
  placeholder?: string;
}

export const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  label = "Editor de texto",
  error = false,
  mensageError = "",
  block = false,
  placeholder = "Digite seu texto aqui..."
}) => {
  // Configuração dos módulos do Quill
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ['link'],
    ],
  };

  // Configuração dos formatos permitidos
  const formats = [
    'bold', 'italic', 'underline',
    'list', 'bullet',
    'link'
  ];

  // Verifica se há conteúdo (remove tags HTML para verificar se há texto)
  const hasContent = value && value.replace(/<[^>]*>/g, '').trim().length > 0;

  return (
    <QuillEditorContainer block={block} isError={error}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        style={{ height: '250px' }}
        className={hasContent ? 'has-content' : ''}
      />
      
      {label && <label className="editor-label">{label}</label>}
      
      {error && <span className="error-message">{mensageError}</span>}
    </QuillEditorContainer>
  );
};
